export const PASSWORD_MIN_LEN = 8;
export const PASSWORD_MAX_LEN = 32;

export function validatePassword(password: string): string | null {
  if (password.length < PASSWORD_MIN_LEN || password.length > PASSWORD_MAX_LEN) {
    return `密码长度须为 ${PASSWORD_MIN_LEN}–${PASSWORD_MAX_LEN} 位`;
  }
  if (!/[A-Za-z]/.test(password)) {
    return "密码须包含字母";
  }
  if (!/\d/.test(password)) {
    return "密码须包含数字";
  }
  return null;
}
